const PdfScreen = {
  title: 'Terms and Conditions',
  share: 'Share',
  errorButton: 'Done',
};

export default PdfScreen;
